gsap.registerPlugin(ScrollTrigger);

console.log('LOADED bh.js');

var clientHeight = document.documentElement.clientHeight;
var clientWidth = document.documentElement.clientWidth;
var aspectRatio = clientWidth / clientHeight;
var isMobile = aspectRatio < 11 / 16;

window.addEventListener('resize', function () {
    console.log('resize for bh.js');
    ScrollTrigger.refresh();
});

var onElementHeightChange = function (elm, callback) {
    var lastHeight = elm.clientHeight, newHeight;

    (function run() {
        newHeight = elm.clientHeight;
        if (lastHeight != newHeight)
            callback(newHeight)
        lastHeight = newHeight

        if (elm.onElementHeightChangeTimer)
            clearTimeout(elm.onElementHeightChangeTimer)

        elm.onElementHeightChangeTimer = setTimeout(run, 200)
    })()
}

onElementHeightChange(document.body, function (h) {
    ScrollTrigger.refresh();
})

// document.addEventListener("shopify:section:load", function (event) {
//     console.log('shopify:section:load');
//     window.location.reload();
// });

var getSectionAttr = function (section) {
    section = $(section);
    var attrs = section.find('.attr');
    var settings = JSON.parse(attrs.text());
    return settings;
};

var parseLinkListOfMenuLink = function (menuLink, linkList) {
    var result = [];
    for (var i = 0; i < linkList.length; i++) {
        if (linkList[i].pid != menuLink.id) {
            continue;
        }
        result.push(linkList[i]);
    }
    return result;
};

var convertLinkList = function (linkList, pid, level) {
    var result = [];
    if (pid == undefined) {
        pid = '0';
    }

    if (level == undefined) {
        level = 0;
    }

    for (var i = 0; i < linkList.length; i++) {
        var link = linkList[i];
        var linkItem = {
            id: pid + '-' + i,
            pid: pid,
            level: level,
            hasChildLevels: link.levels,
            title: link.title,
            url: link.url
        };

        if (link.links.length > 0) {
            result = result.concat(convertLinkList(link.links, linkItem.id, level + 1));
        }
        result.push(linkItem);
    }

    return result;
};

// use global variable for header v2 has imageOf3LevelMenu
var bindRightDrawerHoverEvent = function (linkItem, subLink) {
    linkItem.hover(function (e) {
        if (e.type == 'mouseenter') {
            var itemImg = new Image();

            itemImg.onload = function () {
                $('.header-v2-menu-drawer-1-right .item-image').html(itemImg);
                $('.header-v2-menu-drawer-1-right .item-image').addClass('active');
            };
            
            for (var i = 0; i < imageOf3LevelMenu.length; i++) {
                var image = imageOf3LevelMenu[i];
                if (image.title == subLink.title) {
                    itemImg.src = image.url;
                    break;
                }
            }
        }

        if (e.type == 'mouseleave') {
            $('.header-v2-menu-drawer-1-right .item-image').removeClass('active');
        }
    });
};

var drawer2Tl = gsap.timeline();
var fillDrawer2 = function (linkItem, subMenuList) {
    linkItem.hover(function (e) {
        drawer2Tl.clear();
        $('.header-v2-menu-drawer-1-right .item-wrapper').empty();

        for (var i = 0; i < subMenuList.length; i++) {
            var subLink = subMenuList[i];
            var subLinkItem = $('\
                <a href="' + subLink.url + '" class="header-v2-menu-drawer-title2">\
                    <span>' + subLink.title.toUpperCase() + '</span>\
                </a>\
            ');
            $('.header-v2-menu-drawer-1-right .item-wrapper').append(subLinkItem);
            bindRightDrawerHoverEvent(subLinkItem, subLink);
        }

        if (e.type == 'mouseenter') {
            drawer2Tl = gsap.timeline().to($('.header-v2-menu-drawer-1-right'), {
                opacity: 1,
                visibility: 'visible',
                duration: 0.3
            });
        }

        if (e.type == 'mouseleave') {
            drawer2Tl = gsap.timeline()
                .to($('.header-v2-menu-drawer-1-right'), {}, 0.3)
                .to($('.header-v2-menu-drawer-1-right'), {
                    opacity: 0,
                    duration: 0.3
                })
                .to($('.header-v2-menu-drawer-1-right'), {
                    visibility: 'hidden',
                }, '>');
        }
    });
};

var drawer1Tl = gsap.timeline();
var fillDrawer1 = function (linkItem, subMenuList, menuLinkList) {
    linkItem.hover(function (e) {
        drawer1Tl.clear();
        $('.header-v2-menu-drawer-1-left').empty();
        $('.header-v2-menu-drawer-1-right .item-wrapper').empty();

        for (var i = 0; i < subMenuList.length; i++) {
            var subLink = subMenuList[i];
            var subLinkItem = $('\
                <a href="' + subLink.url + '" class="header-v2-menu-drawer-title1">\
                    <span>' + subLink.title.toUpperCase() + '</span>\
                </a>\
            ');
            if (subLink.hasChildLevels > 0) {
                subLinkItem.addClass('has-child-levels');
                var subSubMenuList = parseLinkListOfMenuLink(subLink, menuLinkList);
                fillDrawer2(subLinkItem, subSubMenuList);
            }
            $('.header-v2-menu-drawer-1-left').append(subLinkItem);
        }

        if (e.type == 'mouseenter') {
            drawer1Tl = gsap.timeline().to($('.header-v2-menu-drawer-1'), {
                opacity: 1,
                visibility: 'visible',
                duration: 0.3
            });
        }

        if (e.type == 'mouseleave') {
            drawer1Tl = gsap.timeline()
                .to($('.header-v2-menu-drawer-1'), {}, 0.3)
                .to($('.header-v2-menu-drawer-1'), {
                    opacity: 0,
                    duration: 0.3
                })
                .to($('.header-v2-menu-drawer-1'), {
                    visibility: 'hidden',
                }, '>');
        }
    });
};

var bindDrawerSelfHoverEvent = function () {
    $('.header-v2-menu-drawer-1-left, .header-v2-menu-drawer-1-right').hover(function (e) {
        drawer1Tl.clear();
        if (e.type == 'mouseenter') {
            drawer1Tl = gsap.timeline().to($('.header-v2-menu-drawer-1'), {
                opacity: 1,
                visibility: 'visible',
                duration: 0.3
            })
        }

        if (e.type == 'mouseleave') {
            drawer1Tl = gsap.timeline()
                .to($('.header-v2-menu-drawer-1'), {}, 0.3)
                .to($('.header-v2-menu-drawer-1'), {
                    opacity: 0,
                    duration: 0.3
                })
                .to($('.header-v2-menu-drawer-1'), {
                    visibility: 'hidden',
                }, '>')
        }
    });


    $('.header-v2-menu-drawer-1-right').hover(function (e) {
        drawer2Tl.clear();
        if (e.type == 'mouseenter') {
            drawer2Tl = gsap.timeline().to($('.header-v2-menu-drawer-1-right'), {
                opacity: 1,
                visibility: 'visible',
                duration: 0.3
            });
        }

        if (e.type == 'mouseleave') {
            drawer2Tl = gsap.timeline()
                .to($('.header-v2-menu-drawer-1-right'), {}, 0.3)
                .to($('.header-v2-menu-drawer-1-right'), {
                    opacity: 0,
                    duration: 0.3
                })
                .to($('.header-v2-menu-drawer-1-right'), {
                    visibility: 'hidden',
                }, '>');
        }
    });
};

var clickFn = function (linkItem, link) {
    linkItem.click(function () {
        window.location.href = link.url;
    });
};

var fillMobileMenu3 = function (linkItem, subMenuList, menuLinkList) {
    linkItem.click(function (e) {
        $('.header-v2-mobile-menu-3').empty();
        var menuBackBtn = $('<div class="header-v2-mobile-menu-back-btn"><<br>' + linkItem.text().toUpperCase() + '</div>');
        menuBackBtn.click(function () {
            $('.header-v2-mobile-menu-drawer-wrapper').css('left', '-100vw');
        });
        $('.header-v2-mobile-menu-3').append(menuBackBtn);
        
        for (var i = 0; i < subMenuList.length; i++) {
            var subLink = subMenuList[i];
            var subLinkItem = $('<div class="header-v2-menu-item">' + subLink.title.toUpperCase() + '</div>');
            clickFn(subLinkItem, subLink);
            $('.header-v2-mobile-menu-3').append(subLinkItem);
        }

        $('.header-v2-mobile-menu-drawer-wrapper').css('left', '-200vw');
    });
};

var fillMobileMenu2 = function (linkItem, subMenuList, menuLinkList) {
    linkItem.click(function (e) {
        $('.header-v2-mobile-menu-2').empty();
        var menuBackBtn = $('<div class="header-v2-mobile-menu-back-btn"><<br>' + linkItem.text().toUpperCase() + '</div>');
        menuBackBtn.click(function () {
            $('.header-v2-mobile-menu-drawer-wrapper').css('left', '0');
        });
        $('.header-v2-mobile-menu-2').append(menuBackBtn);
        
        for (var i = 0; i < subMenuList.length; i++) {
            var subLink = subMenuList[i];
            var subLinkItem = $('<div class="header-v2-menu-item">' + subLink.title.toUpperCase() + '</div>');
            if (subLink.hasChildLevels > 0) {
                subLinkItem.addClass('has-child-levels');
                var subSubMenuList = parseLinkListOfMenuLink(subLink, menuLinkList);
                fillMobileMenu3(subLinkItem, subSubMenuList, menuLinkList);
            } else {
                clickFn(subLinkItem, subLink);
            }

            $('.header-v2-mobile-menu-2').append(subLinkItem);
        }

        $('.header-v2-mobile-menu-drawer-wrapper').css('left', '-100vw');
    });
};

// use global variable for header v2 has linkList
var headerV2Fn = function (section) {
    section = $(section);
    var attr = getSectionAttr(section);
    var menuLinkList = convertLinkList(linkList);

    bindDrawerSelfHoverEvent();

    $('.header-mobile-menu-btn').click(function () {
        $('.header-v2-mobile-menu-drawer').toggleClass('active');

        if ($('.header-v2-mobile-menu-drawer').hasClass('active')) {
            $('.header-v2-mobile-menu-drawer-wrapper').css('left', '0');

            $('.header-mobile-menu-btn .show-btn').hide();
            $('.header-mobile-menu-btn .hide-btn').show();
        } else {
            $('.header-mobile-menu-btn .show-btn').show();
            $('.header-mobile-menu-btn .hide-btn').hide();
        }
    });

    for (var i = 0; i < menuLinkList.length; i++) {
        var link = menuLinkList[i];
        if (link.level > 0) {
            continue;
        }
        var linkItem = $('\
            <div class="header-v2-menu-item">\
                <a href="' + link.url + '" class="header-v2-menu-item-link">' + link.title.toUpperCase() + '</a>\
            </div>'
        );
        if (link.hasChildLevels > 0) {
            linkItem.addClass('has-child-levels');
            var subMenuList = parseLinkListOfMenuLink(link, menuLinkList);
            fillDrawer1(linkItem, subMenuList, menuLinkList);
        }
        section.find('.header-v2-menu').append(linkItem);
    }


    for (var i = 0; i < menuLinkList.length; i++) {
        var link = menuLinkList[i];
        if (link.level > 0) {
            continue;
        }
        var linkItem = $('\
            <div class="header-v2-menu-item">' + link.title.toUpperCase() + '</div>'
        );
        
        if (link.hasChildLevels > 0) {
            linkItem.addClass('has-child-levels');
            var subMenuList = parseLinkListOfMenuLink(link, menuLinkList);
            fillMobileMenu2(linkItem, subMenuList, menuLinkList);
        } else {
            clickFn(linkItem, link);
        }

        section.find('.header-v2-mobile-menu-1').append(linkItem);
    }
};

var headerV2Init = function () {
    var headerV2 = $('.shopify-section--header-v2');
    for (var i = 0; i < headerV2.length; i++) {
        headerV2Fn(headerV2[i]);
    }
};

headerV2Init();

var imageGalleryV2Fn = function (section) {
    section = $(section);
    section.find('.bh-image-gallery-v2__image').eq(0).addClass('active');
    section.find('.bh-image-gallery-v2__image-tag-btn').eq(0).addClass('active');
    section.find('.bh-image-gallery-v2__image-tag-btn').click(function () {
        var index = $(this).index();
        section.find('.bh-image-gallery-v2__image').removeClass('active');
        section.find('.bh-image-gallery-v2__image-tag-btn').removeClass('active');
        section.find('.bh-image-gallery-v2__image').eq(index).addClass('active');
        section.find('.bh-image-gallery-v2__image-tag-btn').eq(index).addClass('active');
    });
};
var imageGalleryV2Init = function () {
    var imageGalleryV2 = $('.bh-image-gallery-v2');
    for (var i = 0; i < imageGalleryV2.length; i++) {
        imageGalleryV2Fn(imageGalleryV2[i]);
    }
};

imageGalleryV2Init();

var revealImageOnScrollFn = function (section) {
    section = $(section);

    var attr = getSectionAttr(section);
    var gradually = attr.gradually;

    var nextSection = section[0].nextElementSibling;
    var clientHeight = document.documentElement.clientHeight;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: 'top+=' + (clientHeight * 1.2) + ' top',
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .fromTo(
                section.find('.bh-reveal-image-on-scroll-v2-image-wrappper')[0],
                {
                    width: '0%',
                    height: '0%'
                },
                {
                    width: '102%',
                    height: '102%',
                    duration: 1
                },
                0
            )
            .fromTo(
                section.find('.bh-reveal-image-on-scroll-v2-image-wrappper img')[0],
                {
                    scale: 1.5
                },
                {
                    scale: 1,
                    duration: 1
                },
                0
            )
            .fromTo(
                trigger,
                {
                    opacity: 1
                },
                {
                    opacity: gradually ? 0 : 1,
                    duration: 0.166666666667
                },
                '>'
            )
    });

    if (gradually) {
        ScrollTrigger.create({
            trigger: nextSection,
            start: 'top-=' + headerHeight + ' top',
            end: 'top+=' + clientHeight * 0.2 + ' top',
            scrub: true,
            pin: true
        });
    }
};

var revealImageOnScrollInit = function () {
    var revealImageOnScroll = $('.bh-reveal-image-on-scroll-v2');
    for (var i = 0; i < revealImageOnScroll.length; i++) {
        revealImageOnScrollFn(revealImageOnScroll[i]);
    }
};

revealImageOnScrollInit();

var slideshowV2Fn = function (section) {
    section = $(section);
    var arrowUrl = section.find('.attr').text().trim();

    var valueIncreaseTime = 1000;
    var valueIncreaseInterval = 10;

    var increaseNum = function (targetDom, targetValue, stepLength) {
        var currentValue = parseInt(targetDom.text());
        var intervalId = setInterval(function () {
            currentValue += stepLength;
            if (currentValue >= targetValue) {
                currentValue = targetValue;
                clearInterval(intervalId);
            }
            targetDom.text(currentValue);
        }, valueIncreaseInterval);
    }

    for (var i = 0; i < section.find('.slideshow-v2-slide-title').length; i++) {
        var title = section.find('.slideshow-v2-slide-title').eq(i);
        title.click(function (e) {
            e.preventDefault();
            var index = $(this).index();
            section.find('.slideshow-v2-slide-wrapper').slick('slickGoTo', index);
        });
    }

    for (var i = 0; i < section.find('.slideshow-v2-value-num').length; i++) {
        var currentVal = Number(section.find('.slideshow-v2-value-num').eq(i).text());
        if (currentVal == 0) {
            section.find('.slideshow-v2-value').eq(i).hide();
            continue;
        }
        section.find('.slideshow-v2-value').eq(i).show();
    }

    section.find('.slideshow-v2-slide-wrapper').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        section.find('.slideshow-v2-slide-title').removeClass('active');
        section.find('.slideshow-v2-slide-title').eq(nextSlide).addClass('active');

        gsap.timeline()
            .to(section.find('.slideshow-v2-slide')[currentSlide], { x: '-10%', duration: 0.3 }, 0)
            .from(section.find('.slideshow-v2-slide')[nextSlide], { x: '10%', duration: 0.3 }, 0)
            .call(function () {
                gsap.set(section.find('.slideshow-v2-slide')[currentSlide], { x: '0%' });
                gsap.set(section.find('.slideshow-v2-slide')[nextSlide], { x: '0%' });
            });

        var power = Number(section.find('.slideshow-v2-slide').eq(nextSlide).attr('power'));
        var top_speed = Number(section.find('.slideshow-v2-slide').eq(nextSlide).attr('top_speed'));
        var top_range = Number(section.find('.slideshow-v2-slide').eq(nextSlide).attr('top_range'));
        var hill = Number(section.find('.slideshow-v2-slide').eq(nextSlide).attr('hill'));
        var max_load = Number(section.find('.slideshow-v2-slide').eq(nextSlide).attr('max_load'));
        var peak_speed = Number(section.find('.slideshow-v2-slide').eq(nextSlide).attr('peak_speed'));

        if (power == 0) {
            section.find('.slideshow-v2-value-power').parent().hide();
        } else {
            section.find('.slideshow-v2-value-power').parent().show();
        }
        if (top_speed == 0) {
            section.find('.slideshow-v2-value-top_speed').parent().hide();
        } else {
            section.find('.slideshow-v2-value-top_speed').parent().show();
        }
        if (top_range == 0) {
            section.find('.slideshow-v2-value-top_range').parent().hide();
        } else {
            section.find('.slideshow-v2-value-top_range').parent().show();
        }
        if (hill == 0) {
            section.find('.slideshow-v2-value-hill').parent().hide();
        } else {
            section.find('.slideshow-v2-value-hill').parent().show();
        }
        if (max_load == 0) {
            section.find('.slideshow-v2-value-max_load').parent().hide();
        } else {
            section.find('.slideshow-v2-value-max_load').parent().show();
        }
        if (peak_speed == 0) {
            section.find('.slideshow-v2-value-peak_speed').parent().hide();
        } else {
            section.find('.slideshow-v2-value-peak_speed').parent().show();
        }

        section.find('.slideshow-v2-value-power').text('0');
        section.find('.slideshow-v2-value-top_speed').text('0');
        section.find('.slideshow-v2-value-top_range').text('0');
        section.find('.slideshow-v2-value-hill').text('0');
        section.find('.slideshow-v2-value-max_load').text('0');
        section.find('.slideshow-v2-value-peak_speed').text('0');

        for (var i = 0; i < section.find('.slideshow-v2-value-num').length; i++) {
            if (i == 0) {
                var targetValue = power;
            } else if (i == 1) {
                var targetValue = top_speed;
            } else if (i == 2) {
                var targetValue = top_range;
            } else if (i == 3) {
                var targetValue = hill;
            } else if (i == 4) {
                var targetValue = max_load;
            } else if (i == 5) {
                var targetValue = peak_speed;
            }
            var targetDom = section.find('.slideshow-v2-value-num').eq(i);
            var stepLength = Math.ceil(targetValue / (valueIncreaseTime / valueIncreaseInterval));
            increaseNum(targetDom, targetValue, stepLength);
        }
    });
    section.find('.slideshow-v2-slide-wrapper').on('init', function (event, slick) {
        section.find('.slideshow-v2-slide-title').eq(0).addClass('active');
    });
    section.find('.slideshow-v2-slide-wrapper').slick({
        arrows: true,
        // variableWidth: true,
        // centerMode: true,
        dots: true,
        fade: true,
        infinite: true,
        appendDots: section.find('.slideshow-v2-slide-wrapper'),
        prevArrow: '<button type="button" class="slick-prev"><img src="' + arrowUrl + '" /></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="' + arrowUrl + '" /></button>',
    });
};

var slideshowV2Init = function () {
    var slideshowV2 = $('.bh-slideshow-v2');
    for (var i = 0; i < slideshowV2.length; i++) {
        slideshowV2Fn(slideshowV2[i]);
    }
}

slideshowV2Init();

var slideshowV3Fn = function (section) {
    section = $(section);
    var arrowUrl = section.find('.attr').text().trim();
    section.find('.slideshow-v3-slide-wrapper').slick({
        arrows: false,
        // variableWidth: true,
        // centerMode: true,
        dots: true,
        infinite: true,
        appendDots: section.find('.slideshow-v3-slide-wrapper'),
        autoplay: true
    });
};

var slideshowV3Init = function () {
    var slideshowV2 = $('.bh-slideshow-v3');
    for (var i = 0; i < slideshowV2.length; i++) {
        slideshowV3Fn(slideshowV2[i]);
    }
}

slideshowV3Init();

var z1SectionImgAnmiV2Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: 'top+=1200 top',
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .to(section.find('.img-anmi-v2-block__img1'), {
                opacity: 0,
                duration: 0.5
            }, 0)
            .from(section.find('.img-anmi-v2-block__img2'), {
                y: '100vh'
            }, 0)
            .from(section.find('.img-anmi-v2-block__img3'), {
                opacity: 0
            }, '>')
    });

};

var z1SectionImgAnmiV2Init = function () {
    var z1SectionImgAnmiV2 = $('.z1-section-img-anmi-v2');
    for (var i = 0; i < z1SectionImgAnmiV2.length; i++) {
        z1SectionImgAnmiV2Fn(z1SectionImgAnmiV2[i]);
    }
};

z1SectionImgAnmiV2Init();

var homeSlideshowV2Fn = function (section) {
    section = $(section);
    
    section.find('.home-slideshow-v2-slide-wrapper').slick({
        arrows: false,
        dots: true,
        // fade: true,
        infinite: true,
        appendDots: section.find('.home-slideshow-v2-slide-wrapper')
    });
};

var homeSlideshowV2Init = function () {
    var homeSlideshowV2 = $('.home-slideshow-v2');
    for (var i = 0; i < homeSlideshowV2.length; i++) {
        homeSlideshowV2Fn(homeSlideshowV2[i]);
    }
};

homeSlideshowV2Init();

var homeCardGroupV2Fn = function (section) {
    section = $(section);
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.home-card-group-v2-card'), {
                y: '20%',
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });
};

var homeCardGroupV2Init = function () {
    var homeCardGroupV2 = $('.home-card-group-v2');
    for (var i = 0; i < homeCardGroupV2.length; i++) {
        homeCardGroupV2Fn(homeCardGroupV2[i]);
    }
};

homeCardGroupV2Init();

var homeSlideshowV4Fn = function (section) {
    section = $(section);
    var arrowUrl = section.find('.attr').text().trim();

    var slick1Dom = section.find('.home-slideshow-v4-slick-wrapper-1');
    var slick2Dom = section.find('.home-slideshow-v4-slick-wrapper-2');
    
    slick1Dom.slick({
        arrows: false,
        dots: false,
        fade: true,
        infinite: true,
        touchMove: false,
        draggable: false
    });

    var centerMode = false;
    if (isMobile) {
        centerMode = true;
    }
    
    slick2Dom.slick({
        arrows: true,
        dots: false,
        infinite: true,
        variableWidth: true,
        centerMode: centerMode,
        touchMove: false,
        draggable: false,
        prevArrow: $('.home-slideshow-v4-slide-2-btn-group .slick-prev'),
        nextArrow: $('.home-slideshow-v4-slide-2-btn-group .slick-next')
    });

    slick2Dom.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        slick1Dom.slick('slickGoTo', nextSlide - 1);
    });

    slick2Dom.slick('slickGoTo', 1);
};

var homeSlideshowV4Init = function () {
    var homeSlideshowV4 = $('.home-slideshow-v4');
    for (var i = 0; i < homeSlideshowV4.length; i++) {
        homeSlideshowV4Fn(homeSlideshowV4[i]);
    }
};

homeSlideshowV4Init();

var homeSlideshowV3Fn = function (section) {
    section = $(section);

    var valueIncreaseTime = 1000;
    var valueIncreaseInterval = 10;

    var increaseNum = function (targetDom, targetValue, stepLength) {
        var currentValue = parseInt(targetDom.text());
        var intervalId = setInterval(function () {
            currentValue += stepLength;
            if (currentValue >= targetValue) {
                currentValue = targetValue;
                clearInterval(intervalId);
            }
            targetDom.text(currentValue);
        }, valueIncreaseInterval);
    }

    var initValues = function (attrArray) {
        section.find('.home-slideshow-v3-performance').html('');

        for (var i = 0; i < attrArray.length; i++) {
            var itemDom = $('\
            <div class="home-slideshow-v3-performance-item">\
                <div class="home-slideshow-v3-performance-item-title">' + attrArray[i].title + '</div>\
                <div class="home-slideshow-v3-performance-item-value">\
                    <span class="home-slideshow-v3-performance-num">0</span>&nbsp;<span class="home-slideshow-v3-performance-unit">' + attrArray[i].unit + '</span>\
                </div>\
            </div>');

            section.find('.home-slideshow-v3-performance').append(itemDom);

            var targetDom = itemDom.find('.home-slideshow-v3-performance-num');
            var targetValue = Number(attrArray[i].number);
            var stepLength = Math.ceil(targetValue / (valueIncreaseTime / valueIncreaseInterval));
            increaseNum(targetDom, targetValue, stepLength);
        }
    };

    var slickDom = section.find('.home-slideshow-v3-slick-wrapper');

    var dotsDom = section.find('.home-slideshow-v3-slick-dots');
    if (isMobile) {
        dotsDom = section.find('.home-slideshow-v3-slick-dots.bh-mobile');
    }

    slickDom.slick({
        arrows: true,
        dots: true,
        infinite: true,
        fade: true,
        touchMove: false,
        draggable: false,
        appendDots: dotsDom,
        prevArrow: $('.home-slideshow-v3-slick-btn .slick-prev'),
        nextArrow: $('.home-slideshow-v3-slick-btn .slick-next')
    });

    var currentAttr = section.find('.home-slideshow-v3-slide').eq(0).find('.product-performance-json').text().trim();
    var currentAttrArray = eval(currentAttr);
    initValues(currentAttrArray);
    section.find('.home-slideshow-v3-slick-btn .home-slideshow-v3-slick-info-link')[0].href = section.find('.home-slideshow-v3-slide').eq(0).find('.home-slideshow-v3-slick-info-link')[0].href;

    slickDom.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var nextSlide = section.find('.home-slideshow-v3-slide').eq(nextSlide);
        var attr = nextSlide.find('.product-performance-json').text().trim();
        var attrArray = eval(attr);
        initValues(attrArray);
        section.find('.home-slideshow-v3-slick-btn .home-slideshow-v3-slick-info-link')[0].href = nextSlide.find('.home-slideshow-v3-slick-info-link')[0].href;
    });
};

var homeSlideshowV3Init = function () {
    var homeSlideshowV3 = $('.home-slideshow-v3');
    for (var i = 0; i < homeSlideshowV3.length; i++) {
        homeSlideshowV3Fn(homeSlideshowV3[i]);
    }
};

homeSlideshowV3Init();

var z1SectionImgAnmiV4Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'bottom top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.img1'), {
                yPercent: 100
            }, 0)
            .from(section.find('.img2'), {
                yPercent: 130
            }, 0)
            .from(section.find('.img3'), {
                yPercent: 160
            }, 0)
            .from(section.find('.img4'), {
                yPercent: 190
            }, 0)
    });
};

var z1SectionImgAnmiV4Init = function () {
    var z1SectionImgAnmiV4 = $('.z1-section-img-anmi-v4');
    for (var i = 0; i < z1SectionImgAnmiV4.length; i++) {
        z1SectionImgAnmiV4Fn(z1SectionImgAnmiV4[i]);
    }
};

z1SectionImgAnmiV4Init();

var z1SectionImgAnmiV5Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'center center',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.anmi'), {
                y: '15vw',
                stagger: 0.1
            }, 0)
            .from(section.find('.z1-section-img-v5-image-dom'), {
                width: '0%',
                height: '0%'
            }, 0.7)
    });
};

var z1SectionImgAnmiV5Init = function () {
    var z1SectionImgAnmiV5 = $('.z1-section-img-anmi-v5');
    for (var i = 0; i < z1SectionImgAnmiV5.length; i++) {
        z1SectionImgAnmiV5Fn(z1SectionImgAnmiV5[i]);
    }
};

z1SectionImgAnmiV5Init();

var z1SectionImgAnmiV6Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    console.log(trigger);

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'bottom top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.foreground'), {
                y: '22vw'
            }, 0)
    });
};

var z1SectionImgAnmiV6Init = function () {
    var z1SectionImgAnmiV6 = $('.z1-section-img-anmi-v6');
    for (var i = 0; i < z1SectionImgAnmiV6.length; i++) {
        z1SectionImgAnmiV6Fn(z1SectionImgAnmiV6[i]);
    }
};

z1SectionImgAnmiV6Init();

var z1SectionCardGroupV2Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.z1-section-card-group-v2-card'), {
                y: '10vw',
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });
};

var z1SectionCardGroupV2Init = function () {
    var z1SectionCardGroupV2 = $('.z1-section-card-group-v2');
    for (var i = 0; i < z1SectionCardGroupV2.length; i++) {
        z1SectionCardGroupV2Fn(z1SectionCardGroupV2[i]);
    }
};

z1SectionCardGroupV2Init();

var z1SectionImgAnmiV3Fn = function (section) {
    section = $(section);

    var width = '68.75vw';
    var height = '22.8125vw';
    var borderRadius = '0.78125vw';

    if (isMobile) {
        width = '100vw';
        height = '99.5555555556vw';
        borderRadius = '0';
    }

    ScrollTrigger.create({
        trigger: section[0],
        start: 'top center',
        end: 'bottom bottom',
        scrub: true,
        animation: gsap.timeline()
            .to(section.find('.img-anmi-v3-block__img-wrapper'), {
                width: width,
                height: height,
                borderRadius: borderRadius
            })
    });

    section.find('.img-anmi-v3-3d-viewer-close-btn').click(function () {
        section.find('.img-anmi-v3-3d-viewer').removeClass('active');
    });

    section.find('.img-anmi-v3-link').click(function () {
        section.find('.img-anmi-v3-3d-viewer').addClass('active');
    });
};

var z1SectionImgAnmiV3Init = function () {
    var z1SectionImgAnmiV3 = $('.z1-section-img-anmi-v3');
    for (var i = 0; i < z1SectionImgAnmiV3.length; i++) {
        z1SectionImgAnmiV3Fn(z1SectionImgAnmiV3[i]);
    }
};

z1SectionImgAnmiV3Init();

var z1SectionImgAnmiV7Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=1500 top',
        pin: true,
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.bh-bg'), {
                opacity: 0.2,
                scale: 1.2,
                duration: 0.5
            }, 0)
            .from(section.find('.z1-section-img-anmi-v7-content-wrapper'), {
                opacity: 0,
                duration: 0.3
            })
            .to({}, {
                duration: 0.3
            })
    });
};

var z1SectionImgAnmiV7Init = function () {

    var z1SectionImgAnmiV7 = $('.z1-section-img-anmi-v7');
    for (var i = 0; i < z1SectionImgAnmiV7.length; i++) {
        z1SectionImgAnmiV7Fn(z1SectionImgAnmiV7[i]);
    }
};

z1SectionImgAnmiV7Init();

var z1SectionImgAnmiV8Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.bh-bg'), {
                opacity: 0
            }, 0)
    });

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=1200 top',
        pin: true,
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.z1-section-img-anmi-v8-content-wrapper'), {
                opacity: 0,
                duration: 0.5
            }, 0)
            .from(section.find('.z1-section-img-anmi-v8-title'), {
                opacity: 0,
                duration: 0.3
            })
            .to({}, {
                duration: 0.3
            })
    });
};

var z1SectionImgAnmiV8Init = function () {
    var z1SectionImgAnmiV8 = $('.z1-section-img-anmi-v8');
    for (var i = 0; i < z1SectionImgAnmiV8.length; i++) {
        z1SectionImgAnmiV8Fn(z1SectionImgAnmiV8[i]);
    }
};

z1SectionImgAnmiV8Init();

var z1SectionCardGroupV3Fn = function (section) {
    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.z1-section-card-group-v3-card'), {
                y: '10vw',
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });
};

var z1SectionCardGroupV3Init = function () {
    var z1SectionCardGroupV3 = $('.z1-section-card-group-v3');
    for (var i = 0; i < z1SectionCardGroupV3.length; i++) {
        z1SectionCardGroupV3Fn(z1SectionCardGroupV3[i]);
    }
};

z1SectionCardGroupV3Init();

var imgTxtCardV2Fn = function (section) {

    section = $(section);

    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;

    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.block-text-wrapper > div'), {
                y: '10vh',
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });

    section.find('.bh-bg').eq(0).addClass('active');

    var btnGroups = section.find('.bh-btn-group');
    btnGroups.each(function (index, btnGroup) {
        $(btnGroup).find('.bh-btn').eq(0).addClass('active');

        $(btnGroup).find('.bh-btn').click(function (e) {
            e.preventDefault();
            var index = $(this).index();
            section.find('.bh-bg').removeClass('active');
            $(btnGroup).find('.bh-btn').removeClass('active');
            section.find('.bh-bg').eq(index).addClass('active');
            $(btnGroup).find('.bh-btn').eq(index).addClass('active');
        });
    });

};

var imgTxtCardV2Init = function () {
    var imgTxtCardV2 = $('.img-txt-card-v2');
    for (var i = 0; i < imgTxtCardV2.length; i++) {
        imgTxtCardV2Fn(imgTxtCardV2[i]);
    }
};

imgTxtCardV2Init();

var z1SectionEffectV2Fn = function (section) {
    section = $(section);
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.z1-section-effect-v2-content .anmi-block'), {
                y: '10vw',
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });

    if (isMobile) {
        ScrollTrigger.create({
            trigger: trigger,
            start: 'top center',
            end: 'center center',
            scrub: true,
            animation: gsap.timeline()
                .fromTo(section.find('.z1-section-effect-v2-bg'), {
                    width: '88vw',
                    height: '190vw'
                }, {
                    width: '100vw',
                    height: '205vw'
                }, 0)
        });
    } else {
        ScrollTrigger.create({
            trigger: trigger,
            start: 'top center',
            end: 'center center',
            scrub: true,
            animation: gsap.timeline()
                .fromTo(section.find('.z1-section-effect-v2-bg'), {
                    width: '87.5vw',
                    height: '37.5vw'
                }, {
                    width: '100vw',
                    height: '50vw'
                }, 0)
        });
    }
};

var z1SectionEffectV2Init = function () {
    var z1SectionEffectV2 = $('.z1-section-effect-v2');
    for (var i = 0; i < z1SectionEffectV2.length; i++) {
        z1SectionEffectV2Fn(z1SectionEffectV2[i]);
    }
};

z1SectionEffectV2Init();

var pinImgSectionEffectFn = function (section) {
    section = $(section);
    var trigger = section[0];

    var attr = getSectionAttr(section);

    if (attr.pin) {
        ScrollTrigger.create({
            trigger: trigger,
            start: 'top top',
            end: 'bottom top',
            pin: true,
            pinSpacing: false
        });
    }
};

var pinImgSectionEffectInit = function () {
    var pinImgSectionEffect = $('.pin-img-section-effect');
    for (var i = 0; i < pinImgSectionEffect.length; i++) {
        pinImgSectionEffectFn(pinImgSectionEffect[i]);
    }
};

pinImgSectionEffectInit();

var z1SectionCardGroupV4Fn = function (section) {
    section = $(section);
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.z1-section-card-group-v4-card'), {
                y: '10vw',
                opacity: 0,
                stagger: 0.05,
                duration: 0.3
            }, 0)
    });
};

var z1SectionCardGroupV4Init = function () {
    var z1SectionCardGroupV4 = $('.z1-section-card-group-v4');
    for (var i = 0; i < z1SectionCardGroupV4.length; i++) {
        z1SectionCardGroupV4Fn(z1SectionCardGroupV4[i]);
    }
};

z1SectionCardGroupV4Init();

var z1SectionImgAnmiV9Fn = function (section) {
    section = $(section);
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.z1-section-img-anmi-v9-content-wrapper div'), {
                y: '10vw',
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });
};

var z1SectionImgAnmiV9Init = function () {
    var z1SectionImgAnmiV9 = $('.z1-section-img-anmi-v9');
    for (var i = 0; i < z1SectionImgAnmiV9.length; i++) {
        z1SectionImgAnmiV9Fn(z1SectionImgAnmiV9[i]);
    }
};

z1SectionImgAnmiV9Init();

var z1SectionCardGroupV5Fn = function (section) {
    section = $(section);
    var trigger = section[0];

    var rows = section.find('.z1-section-card-group-v5-card-row');

    for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        ScrollTrigger.create({
            trigger: row,
            start: 'top center',
            toggleActions: 'play none none reverse',
            animation: gsap.from(rows.eq(i).find('.z1-section-card-group-v5-card'), {
                    y: '10vw',
                    opacity: 0,
                    stagger: 0.1,
                    duration: 0.3
                }, 0)
        });
    }
};

var z1SectionCardGroupV5Init = function () {
    var z1SectionCardGroupV5 = $('.z1-section-card-group-v5');
    for (var i = 0; i < z1SectionCardGroupV5.length; i++) {
        z1SectionCardGroupV5Fn(z1SectionCardGroupV5[i]);
    }
};

z1SectionCardGroupV5Init();


var z1SectionCardGroupV6Fn = function (section) {
    section = $(section);
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.z1-section-card-group-v6-card'), {
                y: '10vw',
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });
};

var z1SectionCardGroupV6Init = function () {
    var z1SectionCardGroupV6 = $('.z1-section-card-group-v6');
    for (var i = 0; i < z1SectionCardGroupV6.length; i++) {
        z1SectionCardGroupV6Fn(z1SectionCardGroupV6[i]);
    }
};

z1SectionCardGroupV6Init();

var storeSectionCardV2Fn = function (section) {
    section = $(section);

    section.find('.store-section-card-v2-slide-wrapper').slick({
        arrows: true,
        variableWidth: true,
        // centerMode: true,
        // dots: true,
        // fade: true,
        draggable: false,
        infinite: false,
        prevArrow: section.find('.slick-btn-group .slick-prev'),
        nextArrow: section.find('.slick-btn-group .slick-next')
    });
};

var storeSectionCardV2Init = function () {
    var storeSectionCardV2 = $('.store-section-card-v2');
    for (var i = 0; i < storeSectionCardV2.length; i++) {
        storeSectionCardV2Fn(storeSectionCardV2[i]);
    }
};

storeSectionCardV2Init();

var storeSectionCardV4Fn = function (section) {
    section = $(section);

    section.find('.store-section-card-v4-slide-wrapper').slick({
        arrows: true,
        variableWidth: true,
        // centerMode: true,
        // dots: true,
        // fade: true,
        draggable: false,
        infinite: false,
        prevArrow: section.find('.slick-btn-group .slick-prev'),
        nextArrow: section.find('.slick-btn-group .slick-next')
    });
};

var storeSectionCardV4Init = function () {
    var storeSectionCardV4 = $('.store-section-card-v4');
    for (var i = 0; i < storeSectionCardV4.length; i++) {
        storeSectionCardV4Fn(storeSectionCardV4[i]);
    }
};

storeSectionCardV4Init();

var storeSectionCardV5Fn = function (section) {
    section = $(section);

    section.find('.store-section-card-v5-slide-wrapper').slick({
        arrows: true,
        variableWidth: true,
        // centerMode: true,
        // dots: true,
        // fade: true,
        draggable: false,
        infinite: false,
        prevArrow: section.find('.slick-btn-group .slick-prev'),
        nextArrow: section.find('.slick-btn-group .slick-next')
    });
};

var storeSectionCardV5Init = function () {
    var storeSectionCardV5 = $('.store-section-card-v5');
    for (var i = 0; i < storeSectionCardV5.length; i++) {
        storeSectionCardV5Fn(storeSectionCardV5[i]);
    }
};

storeSectionCardV5Init();

var specsTableFn = function (section) {
    section = $(section);

    var attr = getSectionAttr(section);
    var tableDataText = attr['table-data'];
    // tableDataText = tableDataText.slice(3, -4);
    console.log(tableDataText);
    var tableDataJson = JSON.parse(tableDataText);
    console.log(tableDataJson);

    var tableDom = section.find('.specs-table-block');

    var rows = tableDataJson.rows;
    var rowHtml = $('<div class="specs-row"></div>');

    for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var rowDom = rowHtml.clone();

        var rowKey = $('<div class="specs-key"></div>');
        var rowValues = $('<div class="specs-values"></div>');

        rowKey.append('<div class="specs-key-title">' + row.key + '</div>');

        if (row.type) {
            rowDom.addClass(row.type);
        }

        for (var j = 0; j < row.values.length; j++) {
            var value = row.values[j];
            var valueDom = $('<div class="specs-value"></div>');
            if (row.type == 'price') {
                valueDom.append('<span class="specs-value-symbol">$</span>');
            }
            valueDom.append(value);
            if (row.type == 'price') {
                valueDom.append('&nbsp;<span class="specs-value-unit">USD</span>');
            }
            rowValues.append(valueDom);
        }

        rowDom.append(rowKey);
        rowDom.append(rowValues);
        tableDom.append(rowDom);
    }
};

var specsTableInit = function () {
    var specsTable = $('.specs-table');
    for (var i = 0; i < specsTable.length; i++) {
        specsTableFn(specsTable[i]);
    }
};

specsTableInit();

var productNavV3Fn = function (section) {
    // listen scroll down and up
    var lastScrollTop = 0;
    var delta = 5;
    var isNavHide = false;
    var navHeight = 0;
    var navDom = $(section).find('.product-nav-v3-bar');
    
    window.addEventListener('scroll', function () {
        var scrollTop = $(this).scrollTop();
        if (Math.abs(lastScrollTop - scrollTop) <= delta) {
            return;
        }
        if (scrollTop > lastScrollTop && scrollTop > navHeight) {
            // down
            if (!isNavHide) {
                isNavHide = true;
                navDom.addClass('product-nav-v3-hide');
                console.log('hide');
            }
        } else {
            // up
            if (isNavHide) {
                isNavHide = false;
                navDom.removeClass('product-nav-v3-hide');
                console.log('show');
            }
        }
        lastScrollTop = scrollTop;
    });
};

var productNavV3Init = function () {
    var productNavV3 = $('.product-nav-v3');
    for (var i = 0; i < productNavV3.length; i++) {
        productNavV3Fn(productNavV3[i]);
    }
};

productNavV3Init();